/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import ChatInserterConfiguration from 'embercom/objects/series/node/chat-inserter-configuration';

export default class ChatNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new ChatInserterConfiguration();
  category = NODE_CATEGORIES.content;
}
